;(() => {
  const STORAGE_KEY = 'hocPopupDismissed'
  const STORAGE_SUBMITTED_KEY = 'hocPopupSubmitted'
  const DELAY = 3000

  function checkForSuccess() {
  const params = new URLSearchParams(window.location.search)
  if (params.has('popup_success')) {
    localStorage.setItem(STORAGE_SUBMITTED_KEY, 'true')
    window.history.replaceState({}, document.title, window.location.pathname)
  }
}

// ← ADD THE NEW FUNCTION RIGHT HERE
function checkForContactSuccess() {
  const params = new URLSearchParams(window.location.search)
  if (!params.has('customer_posted')) return

  const modal = document.getElementById('hoc-popup-modal')
  const form = document.getElementById('hoc-popup-form')
  const successEl = document.getElementById('hoc-popup-success')

  if (!modal || !form || !successEl) return

  modal.classList.add('active')
  document.body.style.overflow = 'hidden'
  form.style.display = 'none'
  successEl.classList.add('active')

  localStorage.setItem('hocPopupSubmitted', 'true')
  window.history.replaceState({}, document.title, window.location.pathname)

const closeBtn = document.querySelector('.hoc-popup-close')
if (closeBtn) {
  closeBtn.addEventListener('click', () => {
    modal.classList.remove('active')
    document.body.style.overflow = ''
  })
}
}



  function initPopup() {
    const trigger = document.getElementById('hoc-popup-trigger')
    const triggerMobile = document.getElementById('hoc-popup-trigger-mobile')
    const triggerMobileClose = document.querySelector('.hoc-popup-trigger-mobile-close')
    const modal = document.getElementById('hoc-popup-modal')
    const closeBtn = document.querySelector('.hoc-popup-close')
    const declineBtn = document.querySelector('.hoc-popup-decline')
    const triggerCloseBtn = document.querySelector('.hoc-popup-trigger-close')
    const overlay = document.querySelector('.hoc-popup-overlay')
    const form = document.getElementById('hoc-popup-form')
    const submitBtn = document.querySelector('.hoc-popup-submit')
    const successEl = document.getElementById('hoc-popup-success')
    const errorEl = document.getElementById('hoc-popup-error')

    if (!modal || !form) return

    const dismissed = localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY)
const submitted = localStorage.getItem(STORAGE_SUBMITTED_KEY)

    if (dismissed || submitted) {
      if (trigger) trigger.classList.add('hidden')
      if (triggerMobile) triggerMobile.classList.add('hidden')
      return
    }

    setTimeout(openModal, DELAY)

    if (trigger) {
      trigger.addEventListener('click', (e) => {
        if (!e.target.classList.contains('hoc-popup-trigger-close')) {
          openModal()
          trigger.classList.remove('visible')
        }
      })
    }

    if (triggerCloseBtn) {
      triggerCloseBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        trigger.classList.add('hidden')
        localStorage.setItem(STORAGE_KEY, 'true')
      })
    }

    if (triggerMobile) {
      triggerMobile.addEventListener('click', (e) => {
        if (!e.target.classList.contains('hoc-popup-trigger-mobile-close')) {
          openModal()
          triggerMobile.classList.remove('visible')
        }
      })
    }

    if (triggerMobileClose) {
      triggerMobileClose.addEventListener('click', (e) => {
        e.stopPropagation()
        triggerMobile.classList.add('hidden')
        localStorage.setItem(STORAGE_KEY, 'true')
      })
    }

    closeBtn.addEventListener('click', () => {
      closeModal(false)
      if (trigger) trigger.classList.add('visible')
      if (triggerMobile) triggerMobile.classList.add('visible')
    })

    declineBtn.addEventListener('click', () => {
      closeModal(false)
      if (trigger) trigger.classList.add('visible')
      if (triggerMobile) triggerMobile.classList.add('visible')
    })

    overlay.addEventListener('click', () => {
      closeModal(false)
      if (trigger) trigger.classList.add('visible')
      if (triggerMobile) triggerMobile.classList.add('visible')
    })

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal(false)
        if (trigger) trigger.classList.add('visible')
        if (triggerMobile) triggerMobile.classList.add('visible')
      }
    })

    form.addEventListener('submit', () => {
  localStorage.setItem(STORAGE_SUBMITTED_KEY, 'true')
  if (trigger) trigger.classList.add('hidden')
  if (triggerMobile) triggerMobile.classList.add('hidden')
  submitBtn.disabled = true
  submitBtn.textContent = 'Submitting...'
})
  }

  function openModal() {
    const modal = document.getElementById('hoc-popup-modal')
    if (modal) {
      modal.classList.add('active')
      document.body.style.overflow = 'hidden'
    }
  }

  function closeModal(permanent = false) {
  const modal = document.getElementById('hoc-popup-modal')
  if (modal) {
    modal.classList.remove('active')
    document.body.style.overflow = ''
  }
  if (permanent) {
    localStorage.setItem(STORAGE_KEY, 'true')
  } else {
    sessionStorage.setItem(STORAGE_KEY, 'true')
  }
}

  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    checkForSuccess()
    checkForContactSuccess()
    initPopup()
  })
} else {
  checkForSuccess()
  checkForContactSuccess()
  initPopup()
}
})()